import { render } from "./AltaPersonal.vue?vue&type=template&id=4c8deab0&scoped=true"
import script from "./AltaPersonal.vue?vue&type=script&lang=js"
export * from "./AltaPersonal.vue?vue&type=script&lang=js"

import "./AltaPersonal.vue?vue&type=style&index=0&id=4c8deab0&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8deab0"]])

export default __exports__